import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
    BooleanInput,
    DateInput,
} from 'react-admin';
import {Grid} from "@mui/material";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminCompaniesHousePeopleCreate = () => {

    return (
        <Create>
            <SimpleForm>
                <Grid container spacing={ 2 }>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <TextInput name="name" source="name" validate={[required()]} />
                        <TextInput name="role" source="role" validate={[required()]} />
                        <BooleanInput name="activeDirector" source="activeDirector" />
                        <BooleanInput name="resigned" source="resigned" />
                    </Grid>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <DateInput name="appointedOn" source="appointedOn" />
                        <ReferenceInput
                            label="Companise House For"
                            source="companiesHouse"
                            reference="companies_house"
                            link="show">
                            <SelectInput optionText="companyName" validate={[required()]} />
                        </ReferenceInput>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}